module.exports = __webpack_public_path__ + "img/small.ded0894e.jpg";